<template>
  <div>
    <div v-for="(group, index) in switchGroups" :key="group.id" :class="{'mb': index < (switchGroups.length - 1)}">

      <h4>{{ group.name }}</h4>

      <div>

        <label>{{ $t('label.emergencyControll') }}:</label>

        <el-button-group>
          <el-button type="primary" @click="toggleGroup(group, 23)">{{ $t('button.openAll') }}</el-button>
          <el-button type="primary" @click="toggleGroup(group, 24)">{{ $t('button.normal') }}</el-button>
          <el-button type="primary" @click="toggleGroup(group, 25)">{{ $t('button.disableAll') }}</el-button>
        </el-button-group>

      </div>

      <br></br>

      <div v-for="(switchx, index) in group.switches" :key="switchx.id" class="switch-box" :class="{'mb': index < (group.switches.length - 1)}">
        <div class="switch">{{ switchx.name }}</div>
        <el-button @click="toggleSwitch(switchx, 3)">{{ $t('button.open') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'switch-controll',
  computed: {
    switchGroups () {
      const groups = this.$store.getters['switch-groups/data'](this.$store.dispatch)
      const switches = this.$store.getters['switches/data'](this.$store.dispatch)

      return groups.map(g => {
        const group = Object.assign({}, g)

        group.switches = group.relatedSwitchIds.map(id => {
          return switches.find(s => s.id === id) || {}
        })

        return group
      })
    }
  },
  methods: {
    toggleSwitch (s, state) {
      post(`api/v1/toggle/${s.id}`, {state})
    },
    toggleGroup (g, state) {
      post(`api/v1/toggle/group/${g.id}`, {state})
    }
  }
}
</script>

<style scoped>
.switch-box {
  margin-left: 20px;
}
.switch {
  display: inline-block;
  width: 50%;
}
.mb {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// SwitchControll.vue?569f335b